// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module--icon--3ksNJ","iconInheritColor":"Icon-module--iconInheritColor--1QxWD","iconShifted":"Icon-module--iconShifted--3_LAy"};